import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "22",
  height: "20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 20"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M11 7.991v3.75m-9.303 3.376c-.865 1.5.217 3.374 1.949 3.374h14.709c1.731 0 2.814-1.874 1.948-3.374L12.95 2.369c-.866-1.5-3.032-1.5-3.898 0L1.697 15.117ZM11 14.74h.008v.008H11v-.008Z",
  stroke: "#fff",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }